import {useContext, useEffect, useState} from 'react';
import Honeybadger from '@honeybadger-io/js';
import TransactionalItemApi from '../services/TransactionalItemApi';
import MemberContext from '../contexts/MemberContext';

const useTkrStoreItemCount = () => {
  const {memberId} = useContext(MemberContext);
  const [tkrStoreItemCount, setTkrStoreItemCount] = useState(0);
  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {
    (async () => {
      if (memberId) {
        try {
          const response = await TransactionalItemApi.getItems({memberId});
          const count = response?.items?.length || 0;
          setTkrStoreItemCount(count);
        } catch (error) {
          Honeybadger.notify(error, 'GetTransactionalItemsError');
        }
      }
    })();
  }, [memberId, refreshToken]);

  const refreshTKRStoreItemCount = () => setRefreshToken(refreshToken + 1);

  return {tkrStoreItemCount, refreshTKRStoreItemCount};
};

export default useTkrStoreItemCount;
